import {clsx} from 'clsx'
import type {ComponentProps} from 'react'

import styles from './CompactCommentButton.module.css'

export const CompactCommentButton = ({className, ...props}: ComponentProps<'button'>) => (
  <button type="button" {...props} className={clsx(styles.CompactCommentInputContainer, className)} />
)

CompactCommentButton.displayName = 'CompactCommentButton'
